import type { Registry as Services } from '@ember/service';
import { tKey } from 'ember-intl';
import {
  KPI_CATEGORIES,
  type KpiCategory,
} from 'lumen/utils/constants/ri-constant-values';

const translationKey = {
  blank: tKey('revenue_insight.blank'),
  contracted_crew: tKey('revenue_insight.contracted_crew'),
  group: tKey('revenue_insight.group'),
  other: tKey('revenue_insight.other'),
  out_of_order: tKey('revenue_insight.out_of_order'),
  total: tKey('revenue_insight.total'),
  transient: tKey('revenue_insight.transient'),
  unmapped: tKey('revenue_insight.unmapped'),
  unsupported: tKey('revenue_insight.unsupported'),
} as const;

export default function kpiCategoryDisplayNameFormatter(
  kpiCategory: KpiCategory | undefined,
  riSelections: Services['ri-selections'],
  intl: Services['intl'],
  useTotalBookedCancelled = false,
): string {
  if (kpiCategory === undefined) {
    return '';
  }

  if (kpiCategory === KPI_CATEGORIES.TOTAL) {
    if (!useTotalBookedCancelled) {
      return intl.t(translationKey[kpiCategory]);
    }

    if (riSelections.isCancellationsOnlyView) {
      return intl.t(tKey('revenue_insight.total_cancelled'));
    }

    return intl.t(tKey('revenue_insight.total_booked'));
  }

  return intl.t(translationKey[kpiCategory]);
}
